export default __webpack_public_path__ + "static/media/image-about-mission-m@3x.5903f5a9.png";